import { useAuth } from '../../contexts/AuthProvider';
import styles from './AuthCallback.module.scss';

export function AuthCallback() {
    const { isLoading, error } = useAuth();

    if (error) {
        return (
            <div className={styles.container}>
                <div className={styles.card}>
                    <h2>Authentication Error</h2>
                    <p className={styles.error}>{error}</p>
                    <a href="/" className={styles.link}>
                        Back to Login
                    </a>
                </div>
            </div>
        );
    }

    if (isLoading) {
        return (
            <div className={styles.container}>
                <div className={styles.card}>
                    <p>Signing you in...</p>
                </div>
            </div>
        );
    }

    return null;
}
